import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
const GetRoles = {
  name: 'roles',
  state: {
    data: [],
    loading: false,
    error: '',
    totalCount: 0,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
        totalCount: 0,
      };
    },

    getReceived(state, payload) {
      return {
        ...state,
        data: payload.data,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getAll({ page, size }) {
      try {
        this.getRequested();
        let url = `savvy/roles/${page}/${size}`;

        const response = await http.get(url);
        this.getReceived({
          data: response.data.data.rows,
          totalCount: response.data.data.count,
        });
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default GetRoles;
